module.exports = __webpack_public_path__ + "static/img/office-img-1.8f70d00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/office-img-1.jpg
// module id = njx0
// module chunks = 0